// import Backbone from 'backbone';

import Modernizr from 'modernizr';
import namespace from '../../upi/namespace';
import appLogger from '@core/LoggingProvider';
import ProductCatalogService from '@services/ProductCatalogService'
import mediaQuery from '@util/media-queries';
import ConfigurationListView from './configurationListView';
import Product from '../models/product';
import ConfigurationList from '../collections/configurationList';
import SkuList from '../collections/skuList';
import OptionGroupList from '../collections/optionGroupList';
import OptionDetailList from '../collections/optionDetailList';
import ImageList from '../collections/imageList';
import PromotionList from '../collections/promotionList';
import ValidationErrorController from './validationErrorController';
import SkuItemController from './skuItemController';
import OptionGroupListView from './optionGroupListView';
import PriceModuleView from './modules/priceModule';
import ProductImageModuleView from './modules/productImageModule';
import PromotionModuleView from './modules/promotionModule';
import Events from '@core/Events';
import {Cart} from '@modules/cart/Cart';
import Modal from '@plugins/modal';
import {noCookieDialog} from '@util/HtmlComponents';
import {getParameterByName} from '@util/URLUtils';

var app = namespace( 'apps.productpage' );

var AppController = Backbone.View.extend( {
    el: '#body-content',

    events: {
        'keypress .qty': 'handleAddToCart',
        'click #addSku': 'handleAddToCart',
        'mouseenter #addSku': function ( e ) {
            this.preFlightValidation( {onError: 'showhint'} );
        }
    },

    initialize: function ( dataLayer ) {
        var self = (app.appController = this);

        self.$el = $( self.el );
        self.$el.removeClass( 'initializing' );

        app.dataLayer = dataLayer;

        app.product = app.ProductModel ? new Product( app.ProductModel ) : null;
        app.context = {
            isEcommerceSite: upi.conf.isEcommerceSite
        };
        app.historyStateIndex = 0;

        // verify we have a working configuration, fail fast
        if ( !app.product || !app.product.get( 'skus' ) ) {
            this.$el.addClass( 'degraded' );
            return;
        }

        self.initializeCollections( app );

        $( document ).ready( function () {
            self.initializeViews( app );
            self.bindEvents( app );
            self.initializeConfigurator( app );

            if ( app.context.isEcommerceSite ) {
                self.renderPromotions( app );
            }

            // get configurator preselect from queryString
            var skuId = getParameterByName( 'sku' );
            var groupId = getParameterByName( 'group' );
            self.loadSelection( {
                skuId: Boolean( skuId ) && skuId,
                groupId: Boolean( groupId ) && parseInt( groupId, 10 )
            } );
        } );

        return this;
    },

    loadSelection: function ( {skuId, groupId} ) {
        if ( skuId ) {
            this.selectSku( skuId );
        }
        else if ( groupId ) {
            this.selectConfiguration( groupId );
        }

        app.historyStateIndex = 0; // reset
    },

    initializeCollections: function ( app ) {
        // Initialize Models
        app.skuList = new SkuList( app.product.get( 'skus' ) );
        app.priceModuleSkuList = new SkuList();
        // depend2s on app.product & app.skuList

        app.promotionList = new PromotionList( app.product.get( 'promotions' ) );
        app.optionDetailList = new OptionDetailList(
            app.product.get( 'optionDetails' )
        );

        //                app.optionGroupList = new OptionGroupList( app.product.get( 'optionGroups' ) );
        app.imageCollection = new ImageList( app.product.get( 'images' ) );
    },

    initializeViews: function ( app ) {
        app.validator = new ValidationErrorController();

        // initialize configurator
        app.priceModuleView = new PriceModuleView( {
            collection: app.priceModuleSkuList
        } );
        app.skuItemController = new SkuItemController();
        app.productImageModuleView = new ProductImageModuleView( {
            sku: app.skuItemController.model,
            collection: app.imageCollection
        } );
    },

    bindEvents: function ( app ) {
        // handle back button
        $( window ).on( 'popstate', function () {
            if ( 0 !== app.historyStateIndex ) {
                window.history.go( app.historyStateIndex );
            }
        } );

        // update:route events should be triggered as early as possible before any views are rendered
        app.mediator.bind( 'update:route', this.handleRouteChange, this );
        app.mediator.bind( 'tooltip:addsku', this.showHint, this );

        this.listenTo( app.mediator, 'set:skulist', function ( skuList ) {
            app.priceModuleSkuList.reset( skuList );
        } );
    },

    scrollToNextTarget: function () {
        var scrollTarget,
            configuration = app.appController.getCurrentSelection(),
            optionGroupListView =
                app.configurationListView.configurationItemViews[configuration.cid]
                    .optionGroupListView;

        if ( configuration.hasGroups() ) {
            scrollTarget = app.configurationListView.getNextTarget();
        }
        else if ( optionGroupListView ) {
            scrollTarget = optionGroupListView.getNextTarget() || '#skuItemDetails';
        }
        else {
            scrollTarget = '#skuItemDetails';
        }

        $( scrollTarget || document.body ).scrollToElement();
    },

    initializeConfigurator: function ( app ) {
        // refactor: SRP
        var configurations = app.product.get( 'configurations' ),
            optionGroups = app.product.get( 'optionGroups' );

        // single sku configurations
        if ( 1 === app.skuList.length ) {
            var sku = app.skuList.first();
            this.setupSku(
                sku // if configuration collection exists
            );
        }
        else if ( configurations && configurations.length ) {
            this.setupConfigurations(
                configurations // else if options exist, only render applicable option groups
            );
        }
        else if ( optionGroups && optionGroups.length ) {
            this.setupOptionGroups( optionGroups );
        }
    },

    setupConfigurations: function ( configurations ) {
        app.configurationList = new ConfigurationList( configurations );
        app.configurationListView = new ConfigurationListView( {
            collection: app.configurationList
        } );
    },

    setupOptionGroups: function ( optionGroups ) {
        app.optionGroupList = new OptionGroupList( optionGroups, {
            skuList: new SkuList( app.skuList.models )
        } );

        app.optionGroupListView = new OptionGroupListView( {
            el: '#productConfiguration',
            collection: app.optionGroupList
        } );

        this.bindOptionGroupListView();
        app.optionGroupListView.render();
    },

    bindOptionGroupListView: function () {
        // handle option invalidations, image collection should default to brand image collection
        app.optionGroupListView.listenTo(
            app.optionGroupList,
            'option:invalidated',
            function () {
                app.imageCollection.reset( app.product.get( 'images' ) );
            }
        );

        // handle option:change when only configuration
        app.optionGroupListView.listenTo(
            app.optionGroupList,
            'change:option',
            function () {
                var options = app.optionGroupList.getSelected(),
                    skuList = this.collection.skuList,
                    sku = skuList.getSkuByOptions( options );

                app.mediator.trigger( 'set:skulist', skuList.models );
                app.mediator.trigger( 'set:sku', sku ); // note: can be undefined
            }
        );
    },

    setupSku: function ( sku ) {
        app.mediator.trigger( 'set:skulist', sku );
        app.mediator.trigger( 'set:sku', sku );
    },

    renderPromotions: function ( app ) {
        var promoViews = $( '<div />' );

        app.promotionList.each( function ( promo ) {
            var pv = new PromotionModuleView( {model: promo} );
            promoViews.append( pv.$el );
        } );

        $( '#promoWrapper' ).html( promoViews );
    },

    selectSku: function ( skuId ) {
        var sku = app.skuList.find( {id: skuId} ), configurationId, optionList;

        if ( sku ) {
            // if a configuration group is present then trigger selection from the top-level
            if ( (configurationId = sku.get( 'groupId' )) ) {
                this.selectConfiguration(
                    configurationId,
                    skuId // else apply selection from the optionsList level
                );
            }
            else if ( (optionList = sku.get( 'options' )) ) {
                this.selectOptions( optionList );
            }
            // set the current sku selection within the priceModule
            app.mediator.trigger( 'set:sku', sku );
        }
    },

    selectOptions: function ( skuOptions ) {
        app.mediator.trigger( 'set:options', skuOptions );
    },

    selectConfiguration: function ( configurationId, skuId ) {
        app.mediator.trigger( 'set:configuration', configurationId, skuId );
    },

    getCurrentSelection: function () {
        return app.optionGroupList
            ? app.optionGroupList
            : app.configurationList ? app.configurationList.current() : 'noop';
    },

    handleRouteChange: function ( selection ) {
        let query = '';
        // keep existing queryParams intact
        let route = window.location.search
            .replace( /(sku|group)=[\w-]+&?/, '' )
            .replace( /&+$/, '' );

        if ( _.has( selection, 'skuList' ) ) {
            query = selection.get( 'type' ) === 'sku'
                ? 'sku=' + selection.get( 'skuId' )
                : 'group=' + selection.get( 'groupId' )
        }
        else {
            query = 'sku=' + selection.get( 'id' );
        }

        route = route === '' || route === '?'
            ? `?${query}`
            : `${route}&${query}`;

        if ( 'pushState' in window.history ) {
            app.historyStateIndex -= 1;
            window.history.pushState( {}, window.title, route );
        }
    },

    preFlightValidation: function ( opt ) {
        opt = opt || {};

        var dfd = $.Deferred(),
            current = this.getCurrentSelection();

        if ( 'noop' === current ) {
            dfd.resolve();
        }
        else if ( current ) {
            current.validate( opt ) ? dfd.resolve() : dfd.reject();
        }
        else {
            var err = {
                error: 'no configuration',
                message: upi.i18n.getTextFromKey( 'lbl-selectOption', 'Please select an option' ),
                el: $( '.option-set:first .group-label' )
            };

            dfd.reject( err );

            switch ( opt.onError ) {
                case 'showerror':
                    console.error( `[ProductConfiguratorError] ${err.message}` );
                    app.validator.trigger( 'error:validation', err );
                    break;
                case 'showhint':
                    // console.log( 'show hint:', err.message );
                    app.mediator.trigger( 'tooltip:addsku', err );
                    break;
                default:
                // fail silent
            }

            //console.log( '@AppController validation failed: no configuration selected' );
        }

        return dfd.promise();
    },

    handleAddToCart: function ( e ) {
        if ( !navigator.cookieEnabled ) {
            Modal.getInstance().open( {content: noCookieDialog, width: 560} );
            return false;
        }

        if ( 'keypress' === e.type && !Events.is_enter_key( e ) ) {
            return true;
        }

        e.preventDefault();
        var self = this;

        return this.preFlightValidation( {onError: 'showerror'} )
            .then(
                () => {
                    return self.addToCart(
                        app.skuItemController.model.toJSON(),
                        app.skuItemController.getQuantity()
                    )
                },
                () => {
                    if ( Modernizr.mq( mediaQuery.min.screenMedium ) ) {
                        // scroll to top of configurator if large device
                        app.appController.$el.scrollToElement();
                    }
                    else {
                        // scroll to error if mobile
                        app.appController.scrollToNextTarget();
                    }
                }
            )
    },

    /**
     * Transform the product configurator model to LineItem entity
     * @param sku
     * @return {{id, customerPrice: *, listPrice: *, product: {sku: *, estimatedShipDate: *|string, productName: *, kitName: *, contents: *, catalogPrice: *, images}}}
     */
    transformSku( sku ) {
        const {id, customerPrice, images, kitContents, itemLongName, itemName, estimatedShipDate, ...rest} = sku;

        return {
            id: sku.id,
            linePrice: customerPrice,
            product: {
                ...rest,
                sku: id,
                // url: '/',
                estimatedShipDate: estimatedShipDate || upi.i18n.getTextFromKey( 'wrd-unknown', 'unknown' ),
                productName: itemName,
                brandName: app.product.get( 'name' ),
                productFamily: '',
                kitName: itemLongName,
                contents: kitContents,
                customerPrice: customerPrice,
                catalogPrice: customerPrice, // note -> fallback to customerPrice (only price provided in model)
                images: images.map( img => ({source: img.src}) )
            }
        };
    },

    addToCart: async function ( sku, qty ) {
        const itemAdditions = {
            ...this.transformSku( sku ),
            quantity: qty
        };

        app.priceModuleView.resetView();

        try {
            const cart = await Cart.add_to_cart( itemAdditions );
            const skuDetail = await ProductCatalogService.getDetail( sku.id );
            itemAdditions.product.url = skuDetail.url;
            Cart.trigger( 'quickadd:item', {...cart, itemAdditions} );
        }
        catch ( err ) {
            this._onAddToCartFailed( err )
        }
    },

    _onAddToCartFailed: err => {
        appLogger.capture( err );
        console.error( `[ProductConfiguratorError] add to cart failed - ${err}` );
        app.mediator.trigger( 'cart:itemnotadded', err );
    },

    processing: function ( isProcessing ) {
        this.isProcessing = isProcessing;
        $( '#addSku' ).toggleClass( 'processing', isProcessing );
    },

    showHint: function ( err ) {
        const msgPart = upi.i18n.getTextFromKey( 'lbl-cartIncompleteMsg', 'to the left before adding to cart' );
        $( '#addSku' ).showHint( `${err.message} ${msgPart}`, {
            placement: 'left'
        } );
    },

    close: function () {
        app.mediator.unbind( 'tooltip:addsku' );
        this.stopListening( app.mediator );

        app.validator.clearChildViews();
        app.priceModuleView.close();
        app.skuItemController.close();
        app.productImageModuleView.close();

        delete app.product;
        delete app.promotionList;
        delete app.skuList;
        app.optionDetailList.destroy();
        delete app.optionDetailList;
        delete app.imageCollection;
        delete app.priceModuleSkuList;

        this.remove();
    }
} );

export default AppController;
